import type { paths } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ProgramsRequestParams = paths['/v3/programs']['get']['parameters']['query'];
type ResponseType = paths['/v3/programs']['get']['responses']['200']['content']['application/json'];

export const getPrograms = async ({ config: { params } }: ConfigRequest<ProgramsRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.program.find, {
    params,
  });
